import { default as crazy_45modeGCqdfGAjUOMeta } from "/Users/federicaprincipe/IdeaProjects/Paradigma/pdg-website/pages/crazy-mode.vue?macro=true";
import { default as indexQmKLoFRLa8Meta } from "/Users/federicaprincipe/IdeaProjects/Paradigma/pdg-website/pages/index.vue?macro=true";
import { default as iso_45certification9kTWHu5aOAMeta } from "/Users/federicaprincipe/IdeaProjects/Paradigma/pdg-website/pages/iso-certification.vue?macro=true";
import { default as voucher_45cloud_45cybersecurityobS7MtDDVKMeta } from "/Users/federicaprincipe/IdeaProjects/Paradigma/pdg-website/pages/voucher-cloud-cybersecurity.vue?macro=true";
export default [
  {
    name: crazy_45modeGCqdfGAjUOMeta?.name ?? "crazy-mode___en",
    path: crazy_45modeGCqdfGAjUOMeta?.path ?? "/en/crazy-mode",
    meta: crazy_45modeGCqdfGAjUOMeta || {},
    alias: crazy_45modeGCqdfGAjUOMeta?.alias || [],
    redirect: crazy_45modeGCqdfGAjUOMeta?.redirect || undefined,
    component: () => import("/Users/federicaprincipe/IdeaProjects/Paradigma/pdg-website/pages/crazy-mode.vue").then(m => m.default || m)
  },
  {
    name: crazy_45modeGCqdfGAjUOMeta?.name ?? "crazy-mode___it",
    path: crazy_45modeGCqdfGAjUOMeta?.path ?? "/crazy-mode",
    meta: crazy_45modeGCqdfGAjUOMeta || {},
    alias: crazy_45modeGCqdfGAjUOMeta?.alias || [],
    redirect: crazy_45modeGCqdfGAjUOMeta?.redirect || undefined,
    component: () => import("/Users/federicaprincipe/IdeaProjects/Paradigma/pdg-website/pages/crazy-mode.vue").then(m => m.default || m)
  },
  {
    name: indexQmKLoFRLa8Meta?.name ?? "index___en",
    path: indexQmKLoFRLa8Meta?.path ?? "/en",
    meta: indexQmKLoFRLa8Meta || {},
    alias: indexQmKLoFRLa8Meta?.alias || [],
    redirect: indexQmKLoFRLa8Meta?.redirect || undefined,
    component: () => import("/Users/federicaprincipe/IdeaProjects/Paradigma/pdg-website/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexQmKLoFRLa8Meta?.name ?? "index___it",
    path: indexQmKLoFRLa8Meta?.path ?? "/",
    meta: indexQmKLoFRLa8Meta || {},
    alias: indexQmKLoFRLa8Meta?.alias || [],
    redirect: indexQmKLoFRLa8Meta?.redirect || undefined,
    component: () => import("/Users/federicaprincipe/IdeaProjects/Paradigma/pdg-website/pages/index.vue").then(m => m.default || m)
  },
  {
    name: iso_45certification9kTWHu5aOAMeta?.name ?? "iso-certification___en",
    path: iso_45certification9kTWHu5aOAMeta?.path ?? "/en/iso-certification",
    meta: iso_45certification9kTWHu5aOAMeta || {},
    alias: iso_45certification9kTWHu5aOAMeta?.alias || [],
    redirect: iso_45certification9kTWHu5aOAMeta?.redirect || undefined,
    component: () => import("/Users/federicaprincipe/IdeaProjects/Paradigma/pdg-website/pages/iso-certification.vue").then(m => m.default || m)
  },
  {
    name: iso_45certification9kTWHu5aOAMeta?.name ?? "iso-certification___it",
    path: iso_45certification9kTWHu5aOAMeta?.path ?? "/certificazioni-iso",
    meta: iso_45certification9kTWHu5aOAMeta || {},
    alias: iso_45certification9kTWHu5aOAMeta?.alias || [],
    redirect: iso_45certification9kTWHu5aOAMeta?.redirect || undefined,
    component: () => import("/Users/federicaprincipe/IdeaProjects/Paradigma/pdg-website/pages/iso-certification.vue").then(m => m.default || m)
  },
  {
    name: voucher_45cloud_45cybersecurityobS7MtDDVKMeta?.name ?? "voucher-cloud-cybersecurity___en",
    path: voucher_45cloud_45cybersecurityobS7MtDDVKMeta?.path ?? "/en/voucher-cloud-cybersecurity",
    meta: voucher_45cloud_45cybersecurityobS7MtDDVKMeta || {},
    alias: voucher_45cloud_45cybersecurityobS7MtDDVKMeta?.alias || [],
    redirect: voucher_45cloud_45cybersecurityobS7MtDDVKMeta?.redirect || undefined,
    component: () => import("/Users/federicaprincipe/IdeaProjects/Paradigma/pdg-website/pages/voucher-cloud-cybersecurity.vue").then(m => m.default || m)
  },
  {
    name: voucher_45cloud_45cybersecurityobS7MtDDVKMeta?.name ?? "voucher-cloud-cybersecurity___it",
    path: voucher_45cloud_45cybersecurityobS7MtDDVKMeta?.path ?? "/voucher-cloud-cybersecurity",
    meta: voucher_45cloud_45cybersecurityobS7MtDDVKMeta || {},
    alias: voucher_45cloud_45cybersecurityobS7MtDDVKMeta?.alias || [],
    redirect: voucher_45cloud_45cybersecurityobS7MtDDVKMeta?.redirect || undefined,
    component: () => import("/Users/federicaprincipe/IdeaProjects/Paradigma/pdg-website/pages/voucher-cloud-cybersecurity.vue").then(m => m.default || m)
  }
]